import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "A list of all the users in your account including their name, title, email\n          and role.")
], -1);
const _hoisted_2 = { class: "mt-8 flex flex-col" };
const _hoisted_3 = { class: "flex flex-col lg:flex-row w-full my-4" };
const _hoisted_4 = { class: "basis-1/5" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", { for: "search-by" }, "Search by:", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("option", { value: "id" }, "User Id", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("option", { value: "email" }, "Email", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", {
    for: "include-archived",
    class: "text-sm text-gray-700"
}, "Include archived users:", -1);
const _hoisted_9 = { class: "basis-4/5 lg:ml-3 mt-4 lg:mt-0" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", { for: "search-user" }, "Search:", -1);
const _hoisted_11 = { class: "flex flex-col sm:flex-row" };
const _hoisted_12 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" };
const _hoisted_13 = { class: "inline-block min-w-full py-2 align-middle px-4 md:px-6 lg:px-8" };
const _hoisted_14 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_15 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("thead", { class: "bg-gray-50" }, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
        }, "User ID\n                  "),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Name"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Email"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", {
            scope: "col",
            class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
        }, "Role(s)")
    ])
], -1);
const _hoisted_17 = { class: "divide-y divide-gray-200 bg-white" };
const _hoisted_18 = { key: 0 };
const _hoisted_19 = {
    key: 0,
    class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center text-lg",
    colspan: "4"
};
const _hoisted_20 = {
    key: 1,
    class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-center text-lg",
    colspan: "4"
};
const _hoisted_21 = { key: 0 };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_24 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_25 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" };
const _hoisted_26 = { key: 0 };
const _hoisted_27 = { key: 1 };
const _hoisted_28 = { key: 2 };
const _hoisted_29 = { key: 3 };
const _hoisted_30 = { key: 4 };
import { UserCircleIcon } from '@heroicons/vue/outline';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import ModalWindow from '@/components/ModalWindow.vue';
import httpClient from '@/httpClient';
import UserForm from './UserForm.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserManagement',
    setup(__props) {
        const store = useStore();
        const profile = computed(() => store.getters.getProfile);
        const showModal = ref(false);
        const searchBy = ref('id');
        const searchTerm = ref('');
        const people = ref([]);
        const selectedUser = ref();
        const searched = ref(false);
        const archived = ref(false);
        const toggleModal = () => {
            showModal.value = !showModal.value;
        };
        const searchUsers = async () => {
            store.dispatch('setIsLoading', true);
            try {
                const payload = {
                    userID: profile.value.userID,
                    searchBy: searchBy.value,
                    searchTerm: searchTerm.value,
                };
                const response = await httpClient.post('/users/list-users', payload);
                searched.value = true;
                people.value = response.data.body?.Items ?? [];
            }
            catch {
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'Could not get user(s) at this time.',
                });
            }
            store.dispatch('setIsLoading', false);
        };
        const handleUserClick = (user) => {
            selectedUser.value = {
                firstName: user.firstName || '',
                surname: user.surname || '',
                userID: user.userID,
                email: user.email,
                jobTitle: user.jobTitle || user.Title || '',
                roles: [],
                emailPrefs: user.emailPrefs,
                archived: user.archived || false,
            };
            ['ADMIN', 'H2R', 'HM', 'HROPS', 'RESOURCING'].forEach((key) => {
                if (user[key]) {
                    selectedUser.value.roles.push(key);
                }
            });
            toggleModal();
        };
        const createNewUser = () => {
            selectedUser.value = undefined;
            toggleModal();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", { class: "sm:flex sm:items-center" }, [
                    _hoisted_1,
                    _createTextVNode(),
                    _createElementVNode("div", { class: "mt-4 sm:mt-0 sm:ml-16 sm:flex-none" }, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                            onClick: createNewUser
                        }, "Add user")
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("select", {
                                id: "search-by",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchBy).value = $event)),
                                class: "mb-2 grow block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                name: "search-by"
                            }, [
                                _hoisted_6,
                                _createTextVNode(),
                                _hoisted_7
                            ], 512), [
                                [_vModelSelect, searchBy.value]
                            ]),
                            _createTextVNode(),
                            _hoisted_8,
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("input", {
                                id: "include-archived",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((archived).value = $event)),
                                type: "checkbox",
                                name: "include-archived",
                                class: "focus:ring-indigo-500 h-3 w-3 ml-2 text-indigo-600 border-gray-300 rounded disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed"
                            }, null, 512), [
                                [_vModelCheckbox, archived.value]
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((searchTerm).value = $event)),
                                    class: "basis-4/5 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
                                    type: "text",
                                    name: "search-user"
                                }, null, 512), [
                                    [_vModelText, searchTerm.value]
                                ]),
                                _createTextVNode(),
                                _createElementVNode("button", {
                                    class: "basis-1/5 sm:ml-2 mt-2 sm:mt-0 w-full inline-flex justify-center rounded-md border border-transparent bg-green-700 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-green-800 hover:underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                    onClick: _withModifiers(searchUsers, ["prevent"])
                                }, "Search")
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("table", _hoisted_15, [
                                    _hoisted_16,
                                    _createTextVNode(),
                                    _createElementVNode("tbody", _hoisted_17, [
                                        (!people.value.length)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                                                (!searched.value)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_19, "Please use the search bar to search for user(s)"))
                                                    : (_openBlock(), _createElementBlock("td", _hoisted_20, "No\n                    users found..."))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(people.value, (person) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                                key: person.email
                                            }, [
                                                (archived.value || !person.archived)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                                                        _createElementVNode("td", {
                                                            class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-blue-700 sm:pl-6 hover:underline cursor-pointer",
                                                            onClick: _withModifiers(($event) => (handleUserClick(person)), ["prevent"])
                                                        }, _toDisplayString(person.userID), 9, _hoisted_22),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", _hoisted_23, _toDisplayString(person.Title), 1),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", _hoisted_24, _toDisplayString(person.email), 1),
                                                        _createTextVNode(),
                                                        _createElementVNode("td", _hoisted_25, [
                                                            (person.ADMIN)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "ADMIN "))
                                                                : _createCommentVNode("", true),
                                                            _createTextVNode(),
                                                            (person.H2R)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "H2R "))
                                                                : _createCommentVNode("", true),
                                                            _createTextVNode(),
                                                            (person.HM)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "HM "))
                                                                : _createCommentVNode("", true),
                                                            _createTextVNode(),
                                                            (person.HROPS)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "HROPS "))
                                                                : _createCommentVNode("", true),
                                                            _createTextVNode(),
                                                            (person.RESOURCING)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "RESOURCING "))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ], 64));
                                        }), 128))
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                (showModal.value)
                    ? (_openBlock(), _createBlock(ModalWindow, {
                        key: 0,
                        size: "5xl",
                        onClose: toggleModal
                    }, {
                        icon: _withCtx(() => [
                            _createVNode(_unref(UserCircleIcon), {
                                class: "h-12 w-12 text-green-600",
                                "aria-hidden": "true"
                            })
                        ]),
                        title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedUser.value ? 'Edit User' : 'Add User'), 1)
                        ]),
                        subtitle: _withCtx(() => [
                            _createTextVNode("Please fill out the details of the user")
                        ]),
                        main: _withCtx(() => [
                            _createVNode(UserForm, {
                                "existing-user": selectedUser.value,
                                onCancel: toggleModal
                            }, null, 8, ["existing-user"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
